import {Material, MaterialType} from '@domain/materials'

import {AdditivesForClinkerClassificationRow} from './AdditivesForClinkerClassificationRow'
import {CementClassificationRow} from './CementClassificationRow'
import {ClinkerClassificationRow} from './ClinkerClassificationRow'
import {EnhancersForCementClassificationRow} from './EnhancersForCementClassificationRow'
import {FuelsClassificationRow} from './FuelsClassificationRow'
import {IntermediateAndFinishedProductsClassificationRow} from './IntermediateAndFinishedProductsClassificationRow'
import {OtherGroundProductsThanCementClassificationRow} from './OtherGroundProductsThanCementClassificationRow'
import {OtherPyroProductsThanClinkerClassificationRow} from './OtherPyroProductsThanClinkerClassificationRow'
import {RawMaterialsClassificationRow} from './RawMaterialsClassificationRow'

export const ClassificationRow = ({material}: {material: Material}) => {
  switch (material.type) {
    case MaterialType.Cement:
      return <CementClassificationRow material={material} />
    case MaterialType.Clinker:
      return <ClinkerClassificationRow material={material} />
    case MaterialType.IntermediateAndFinishedProducts:
      return <IntermediateAndFinishedProductsClassificationRow material={material} />
    case MaterialType.RawMaterials:
      return <RawMaterialsClassificationRow material={material} />
    case MaterialType.Fuels:
      return <FuelsClassificationRow material={material} />
    case MaterialType.EnhancersForCement:
      return <EnhancersForCementClassificationRow material={material} />
    case MaterialType.AdditivesForClinker:
      return <AdditivesForClinkerClassificationRow material={material} />
    case MaterialType.OtherGroundProductsThanCement:
      return <OtherGroundProductsThanCementClassificationRow material={material} />
    case MaterialType.OtherPyroProductsThanClinker:
      return <OtherPyroProductsThanClinkerClassificationRow material={material} />
    default:
      return null
  }
}
